// Shared DMS form constants + line-item key helpers.
export const CURRENCIES = ["UGX", "USD", "CAD", "EUR", "GBP", "KES"];

export const SIGNERS = [
  { name: "Jerome Gerald Lutaya", title: "Director" },
  { name: "Tony Lutaaya", title: "Manager" },
];

// Stable client-side keys for line items so React reconciliation survives
// splice/reorder. The `_key` field is stripped before the payload hits the API.
export const newKey = () => `k_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
export const withKey = (obj) => ({ _key: obj._key || newKey(), ...obj });
export const stripKey = (arr) => (arr || []).map(({ _key, ...rest }) => rest);

export const empty = (docType) => ({
  doc_type: docType,
  client_name: "", client_address: "", client_branch: "",
  client_contact_person: "", client_contact_phone: "", client_email: "",
  title: "", project_location: "", currency: "UGX",
  date: new Date().toISOString().slice(0, 10),
  valid_until: "30 days", payment_terms: "50% on confirmation, 50% on delivery",
  delivery_terms: "Within 5 working days",
  due_date: "", lpo_reference: "", related_quotation: "",
  notes: "",
  items: [withKey({ description: "", unit_of_measure: "Pcs", qty: 1, unit_price: 0, supplied_by: "Jero-One", serial_no: "", cost_price: 0, margin_pct: 0 })],
  sourcing_intel: [], spec_summary: "",
  tax_rate: 18, tax_inclusive: false,
  signed_by: "",
  prepared_by: "",
  bank: "",
  service_type: "", priority: "Normal", technician: "", job_date: "",
  scope_tasks: [], work_status: [], time_log: [],
  related_job_card: "", feedback_comments: "",
  supplier_id: "",
});
